import { Text } from 'slate'

export const withPrompt = editor => {
  const { isInline, markableVoid } = editor

  editor.isInline = element =>
    ['highlightInput'].includes(element.type) ? true : isInline(element)
  return editor
}

export const convertToSlateNodes = text => {
  const nodes = []
  let currentText = ''

  const addTextAndReset = () => {
    if (currentText !== '') {
      nodes.push({ text: currentText })
      currentText = ''
    }
  }

  for (let i = 0; i < text.length; i++) {
    if (text[i] === '【') {
      addTextAndReset()

      let closingIndex = text.indexOf('】', i + 1)
      if (closingIndex !== -1) {
        const highlightedText = text.substring(i + 1, closingIndex)
        nodes.push({
          type: 'highlightInput',
          children: [{ text: highlightedText }],
        })
        i = closingIndex
      }
    } else {
      currentText += text[i]
    }
  }

  addTextAndReset()

  return [
    {
      type: 'paragraph',
      children: nodes,
    },
  ]
}
